import { CriteriaType } from '@constants'
import { GETSearchType } from '@types'

import type { SearchAssistantRepository } from '../repository/search-assistant.repository'

export class SearchAssistantController {
  constructor(private searchAssistantRepository: SearchAssistantRepository) {}

  public saveDefaultSearchFilter(defaultSearchFilter: GETSearchType | null) {
    this.searchAssistantRepository.saveDefaultSearchFilter(defaultSearchFilter)
  }

  public saveSelectedFavouriteCriteria(selectedFavouriteCriteria: GETSearchType | null) {
    this.searchAssistantRepository.saveSelectedFavouriteCriteria(selectedFavouriteCriteria)
  }

  public saveCriterias(criterias: CriteriaType[]) {
    this.searchAssistantRepository.saveCriterias(criterias)
  }

  public closeFilterManager(dialogId: string) {
    this.searchAssistantRepository.closeFilterManager(dialogId)
  }

  public disposeSearchAssistant() {
    this.searchAssistantRepository.disposeSearchAssistant()
  }
}
